import React, { useRef, useState } from 'react';
import { BrowserQRCodeReader } from '@zxing/browser';
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import MODAL_TABLE from '../../../../main_components/modal/modal_Table';
import { bussines_partnert_put, bussines_partnert_put_qr } from '../../../../services/businesspartners/businesspartners';
import { verifyToken } from '../../../../main_components/tokens/verifyToken';
import { BUSSINES_PARTNER, RESPONSE } from '../interface/interface';
import { supplier_get } from '../../../../services/expenses/expense';

interface CustomTableProps {
  data: any;
}

const CustomQR: React.FC<CustomTableProps> = ({ data }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [modalT, setModalT] = useState(false);
    const [messgeNotFound, setMessgeNotFound] = useState("");
    const [enableButton, setEnableButton] = useState(false);
    const [enableButtonNotFound, setEnableButtonNotFound] = useState(false);
    const [dataResponse, setdataResponse] = useState<any>({});
    const [imagePreview, setImagePreview] = useState<string | null>(null);

    const [rfc, setrfc] = useState(""); 
    const [type_Suplier, setType_suplier] = useState(false);
    const [update_type, setupdate_type] = useState(false);

    const navigate = useNavigate();

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const imageUrl = URL.createObjectURL(file);
        setImagePreview(imageUrl);

        const img = new Image();
        img.src = imageUrl;

        img.onload = async () => {
            const codeReader = new BrowserQRCodeReader();
            try {
                const result = await codeReader.decodeFromImageElement(img);
                if (result) {
                    await handle_response_url(result.getText());
                }
            } catch (err) {
                console.error('Error al leer QR:', err);
                setMessgeNotFound("No se pudo leer un código QR válido en la imagen.");
                setEnableButton(false);
                setEnableButtonNotFound(false);
            }
        };
    };

    const handle_response_url = async (url: string) => {
        setModalT(true);
        setType_suplier(false);
        setupdate_type(false);

        try {
            const response = await bussines_partnert_put_qr({ url });
            console.log('Respuesta del servidor:', response);
            setMessgeNotFound("El socio de negocios fue actualizado correctamente en el sistema.");
            validar_rfc(url);
        } catch (error: any) {
            console.log(error);
            if (error.status === 404 && error.response?.data) {
                const data = error.response.data;
                const bp = data.business_partner || {};
                const addr = data.address || {};
                const filledObject = {
                    code: "",
                    business_partner: bp.business_partner ?? null,
                    rfc: bp.rfc ?? null,
                    paymethod: "01",
                    allow_invoicing: false,
                    name: bp.name ?? null,
                    force_code: false,
                    first_last_name: bp.first_last_name ?? null,
                    second_last_name: bp.second_last_name ?? null,
                    capital_regime: bp.capital_regime ?? null,
                    cfdi_use: "G03",
                    tax_residence: null,
                    num_reg_id_trib: null,
                    metodo_pago: "PUE",
                    tax_regime: bp.tax_regime ?? "616",
                    email: bp.email ?? null,
                    enable: true,
                    person_type: bp.rfc.length === 12 ? "MORAL" : "FISICA",
                    zip_code: addr.zip_code ?? null,
                    street: addr.street ?? null,
                    city: addr.city ?? null,
                    outdoor_number: addr.outdoor_number ?? null,
                    inside_number: addr.inside_number ?? null,
                    state: addr.state ?? "VERACRUZ DE IGNACIO DE LA LLAVE",
                    reference: null,
                    outer_code: null,
                    account_number: null,
                    id_accounting_account_fk: null,
                    name_accounting_account: null,
                    code_accounting_account: null,
                    address_type: "FISCAL",
                    country: "MÉXICO",
                    town: null,
                    subsidiary: "MATRIZ",
                    neighborhood: addr.neighborhood ?? null,
                    partner_type: "PROPIO",
                    credit_days: null,
                    business_partner_type: "CLIENTE",
                };

                setdataResponse(filledObject);
                setMessgeNotFound(data.errorMessage.es);
                setEnableButtonNotFound(true);
            }
        } finally {
            setEnableButton(true);
            setModalT(false);
        }
    };

    
      const validar_rfc = (url:string) => {
    
        const params = new URL(url).searchParams;
        const d3 = params.get("D3");
        const rfc = d3?.split("_")[1];
        if(rfc){
          setrfc(rfc);
          const data_bussiness_rfc = data.filter((item:any)=>item.rfc === rfc);
          if(data_bussiness_rfc.length === 0){
            setType_suplier(true);
          }else{
            setType_suplier(false);
          }
        }else{
          console.log("RFC inválido o no definido");
        }
      }
    
    
     const handleBussinesPartner = async (event?: React.SyntheticEvent): Promise<void> => {
        event?.preventDefault();
        setModalT(true);
        const isTokenValid = await verifyToken();
        if (!isTokenValid) {
          setTimeout(() => {
            handleBussinesPartner();
          }, 1000);
          return;
        }
        try{
          const data = await fetchBussinesPartner();
          const data_supp = data.filter((item:any)=> item.rfc === rfc);
          console.log(data_supp); 
          if(data_supp && data_supp.length){
            update_supplier(data_supp);
          }else{setModalT(false);}
        }catch(err){
          setModalT(false);
        }
      };

       const fetchBussinesPartner = async (): Promise<BUSSINES_PARTNER[]> => {
          try {
            const rawResponse = await supplier_get();
            const response: RESPONSE = Array.isArray(rawResponse)
              ? { data: rawResponse }
              : rawResponse;
            return response.data;
          } catch (error) {
            console.error("Error al obtener los datos de paginación:", error);
            setModalT(false);
            return [];
          }
        };
    
      const update_supplier = async(data_supp:any) =>{
        try{
          const supp = data_supp[0];
          var dat = {
            "business_partner": {
              "business_partner": supp.business_partner,
              "rfc": supp.rfc,
              "business_partner_type": "AMBOS",
              "enable": supp.enable
            },
            "address":{}
          }
          const response = await bussines_partnert_put(dat, supp.id);
          console.log(response);
          setModalT(false);
          setType_suplier(false);
          setupdate_type(true);
    
        }catch(err){
          console.log(err);
          setModalT(false);
        }
      }
    

    const handle_redirect_page = () => {
        navigate('/CUSTOM_QR_PARTNER', {
            state: { myObject: dataResponse }
        });
    };

    const handle_reload_page = () => {
        navigate('/temporary-route');
        setTimeout(() => navigate('/BUSSINES_PARTNER_TS'), 50);
    };

    return (
        <Container maxWidth="sm">
            <MODAL_TABLE open={false} message={''} message2={''} modalGeneral={false} modalT={modalT} />

            <Stack spacing={2} sx={{ py: 2 }}>
                {/* Botón para seleccionar imagen */}
                <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />

                <Button
                    variant="contained"
                    onClick={() => fileInputRef.current?.click()}
                >
                    Subir Imagen con QR
                </Button>

                {/* Vista previa */}
                {imagePreview && (
                    <Box
                        component="img"
                        src={imagePreview}
                        alt="Vista previa del QR"
                        sx={{ width: '100%', border: '2px solid #e0e0e0', borderRadius: 2 }}
                    />
                )}

                {/* Mensaje de estado */}
                <Typography>{messgeNotFound}</Typography>
                {
                    type_Suplier === true 
                    ? <>
                        <div style={{color:"black", textAlign: "justify", backgroundColor: "#f9e79aff", padding:"7px"}}>
                        <p><b>Nota:</b> Actualmente, este socio de negocios está registrado como proveedor. <br/>
                            ¿Desea actualizar el tipo de socio a <b>cliente/proveedor</b>?
                        </p>
                        <button 
                            style={{width:"100%", borderRadius:"5px", backgroundColor: "#ab8919ff"}}
                            onClick={()=>{handleBussinesPartner()}}
                        >ACTUALIZAR TIPO DE SOCIO</button>
                        </div>
                        </>
                    :<></>
                }
                {
                    update_type === true
                    ? <div style={{textAlign: "justify", backgroundColor: "#a2f99aff", padding: "7px"}}>
                        Se ha actualizado correctamente el tipo de socio.
                        </div>
                    :<></>
                }   
                {/* Botón de redirección */}
                {enableButtonNotFound && (
                    <Button
                        fullWidth
                        size="large"
                        variant="contained"
                        sx={{ bgcolor: '#5B21B6', '&:hover': { bgcolor: '#4C1D95' } }}
                        onClick={handle_redirect_page}
                    >
                        REGISTRAR NUEVO SOCIO
                    </Button>
                )}

                {/* Botón de recarga */}
                {enableButton && (
                    <Button
                        fullWidth
                        size="large"
                        variant="contained"
                        sx={{ bgcolor: '#059669', '&:hover': { bgcolor: '#047857' } }}
                        onClick={handle_reload_page}
                    >
                        ACTUALIZAR TABLA
                    </Button>
                )}
            </Stack>
        </Container>
    );
};

export default CustomQR;
